module.exports = __webpack_public_path__ + "media/images/icons/arrow-f80208bca3d372cd59ba08b87d7900f9.svg";